module.exports = __webpack_public_path__ + "jm.svg?3053a605fca4ce752bf47d75f65b0552";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/jm.svg
// module id = 845
// module chunks = 27